import { render, staticRenderFns } from "./custom-component.vue?vue&type=template&id=f35817fc&scoped=true&"
import script from "./custom-component.vue?vue&type=script&lang=js&"
export * from "./custom-component.vue?vue&type=script&lang=js&"
import style0 from "./custom-component.vue?vue&type=style&index=0&id=f35817fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35817fc",
  null
  
)

export default component.exports